/**
 * Get the locale given the langcode. Falls back to Swiss German.
 */
export function getLocale(langcode: string): string {
  switch (langcode) {
    case 'en':
      return 'en-GB'
    case 'fr':
      return 'fr-CH'
    case 'it':
      return 'it-CH'
  }
  return 'de-CH'
}

export const LANGUAGE_LABEL: Record<string, string> = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Francais',
  it: 'Italiano',
}
